import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.TaskPage.components.UploadTaskFileDialog.title',
    defaultMessage: 'Upload on behalf of voice talent',
  },
  cancel: {
    id: 'containers.OrderPage.components.TaskPage.components.UploadTaskFileDialog.cancel',
    defaultMessage: 'Cancel',
  },
  loading: {
    id: 'containers.OrderPage.components.TaskPage.components.UploadTaskFileDialog.loading',
    defaultMessage: 'Uploading..',
  },
  submit: {
    id: 'containers.OrderPage.components.TaskPage.components.UploadTaskFileDialog.submit',
    defaultMessage: 'Upload',
  },
  sideEffects: {
    id: 'containers.OrderPage.components.TaskPage.components.UploadTaskFileDialog.sideEffects',
    defaultMessage: `
      <li>.pdf, .zip, .wav, .mp3, .docx, .xlsx are supported</li>
      <li>10 GB limit for each file uploaded</li>
      <li>Uploaded ZIP archives will be auto extracted</li>
    `
  },
})
